/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
export class WebscriptApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.allowedMethod = ['GET', 'POST', 'PUT', 'DELETE'];
    }
    executeWebScript(httpMethod, scriptPath, scriptArgs, contextRoot, servicePath, postBody) {
        contextRoot = contextRoot || 'alfresco';
        servicePath = servicePath || 'service';
        postBody = postBody || null;
        if (!httpMethod || this.allowedMethod.indexOf(httpMethod) === -1) {
            throw new Error('method allowed value  GET, POST, PUT and DELETE');
        }
        if (!scriptPath) {
            throw new Error('Missing param scriptPath in executeWebScript');
        }
        const contentTypes = ['application/json'];
        const accepts = ['application/json', 'text/html'];
        return this.apiClient.callApi('/' + servicePath + '/' + scriptPath, httpMethod, {}, scriptArgs, {}, {}, postBody, contentTypes, accepts, null, contextRoot);
    }
}
